module.exports = __webpack_public_path__ + "img/sys-icon-2.566a77e.png";